import React from 'react'

import {connect} from 'react-redux'
import IconButton from 'material-ui/IconButton'
import DownloadIcon from 'material-ui/svg-icons/file/file-download'

import DateView from '../../common/date/DateView'
import WorkerFilterButton from '../../common/WorkerFilterButton'
import JobColumnFilter from './JobColumnFilter'
import PrintButton from './PrintButton'
import SettingsButton from './SettingsButton'

class ReportHeader extends React.Component {

  static Title = {
    payroll: 'Time Sheets',
    serviceSummary: 'Service and Recurring Jobs',
    timeAllocation: 'Time Allocation Report'
  }

  constructor(props) {
    super(props)
    this.state = {
      report: props.report,
      singleDay: props.singleDay,
      currentReport: this.returnCurrentReport(props)
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      report: nextProps.report,
      singleDay: nextProps.singleDay,
      currentReport: this.returnCurrentReport(nextProps)
    })
  }

  returnCurrentReport(props) {
    if (props.currentReportType) {
      return props.currentReportType
    }
    const url = window.location.href
    const path = url.split('/')
    const type = path[path.length - 1]
    this.props.dispatch({
      type: 'REPORTS_TYPE',
      label: 'TYPE',
      value: type
    })
    return type
  }

  render() {
    return (
      <div
        style={{
          flexDirection: 'column',
          padding: 32,
          borderBottom: '1px solid #e2e2e2' }}>
        <div
          style={{ display: 'flex', flexDirection: 'row',
            justifyContent: 'space-between', alignItems: 'flex-start' }}>

          <div
            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center',
              marginBottom: 12 }}>
            <span
              style={{ display: 'flex', justifyContent: 'flex-start', fontSize: 24 }}>
              { ReportHeader.Title[this.state.report] }
            </span>
          </div>

          <div>
            <IconButton
              onTouchTap={this.props.onCSVExport}>
              <DownloadIcon
                color={'rgba(0,0,0,0.33)'}/>
            </IconButton>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <DateView
            startDateStr={this.props.startDateStr}
            endDateStr={this.props.endDateStr}
            singleDay={this.state.singleDay}
            showArrows={true}
            showTimePeriod={this.props.showTimePeriod}
            onDateChange={this.props.onDateChange} />

          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <WorkerFilterButton onSelectionChange={this.props.onWorkerSelectionChange}/>
            { this.props.report !== 'timeAllocation' && <JobColumnFilter /> }
            { this.props.report === 'timeAllocation' && <PrintButton onPrint={this.props.onPrintReport}/> }
            { this.props.report === 'timeAllocation' && <SettingsButton onSettingsChange={this.props.onSettingsChange}/> }
          </div>
        </div>
      </div>
    )
  }

}

function mapStateToProps(state){
  const props = {}
  if (state.reports && state.reports.uiData) {
    props['currentReportType'] = state.reports.uiData.type
  }
  return props
}

export default connect(mapStateToProps)(ReportHeader)



// WEBPACK FOOTER //
// ./src/reports/common/ReportHeader.js